import { forwardRef, useEffect } from 'react';
import useDictationConfig from '../../hooks/useDictationConfig';
import classes from './Page.module.scss'
import clsx from 'clsx';
import { useRef } from 'react';
import { useImperativeHandle } from 'react';

const DELAY_FOCUS_NOTE = 1200;
const DELAY_FOCUS_CLICK_BANK = 100;
const Page = forwardRef(function Page(props, ref) {
    const { reduceHeight, className, style = {}, ...htmlProps } = props;
    const { backGroundNoteImage } = useDictationConfig();
    const noteRef = useRef(null);
    useImperativeHandle(ref, () => noteRef?.current);

    useEffect(() => {
        setTimeout(() => {
            noteRef.current.focus();
        }, DELAY_FOCUS_NOTE);
    }, [noteRef])

    useEffect(() => {
        const moveFocusToNote = () => {
            setTimeout(() => {
                noteRef.current.focus();
            }, DELAY_FOCUS_CLICK_BANK);
        }
        window.addEventListener("audioVelocityChange", moveFocusToNote)
        return () => {
            window.removeEventListener("audioVelocityChange", moveFocusToNote)
        }
    }, [])

    return (
        <div className={classes.wrapper}>
            <div className={classes.container}>
                <div
                    ref={noteRef}
                    className={clsx(className, classes.page, classes.scrollbar, reduceHeight && classes.mobiledisplay)}
                    style={{ backgroundImage: `url(${backGroundNoteImage})`, ...style }}
                    {...htmlProps}
                />
            </div>
        </div>
    )
});

export default Page;
